<template>
  <div id="app" class="wrapper">
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <div class="cart">
        <br />
        <h1 class="title cor-preta">Meu Carrinho</h1>
        <table class="table is-striped">
          <thead>
            <tr>
              <td>
                <label class="cor-preta"><b>Pedido</b></label>
              </td>
              <td>
                <label class="cor-preta"><b>Preço</b></label>
              </td>
              <!--<td><b>Subtotal</b></td>-->
              <td><b></b></td>
              <td>
                <label class="cor-preta"><b></b></label>
              </td>
              <td><b></b></td>
              <td><b></b></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(p, idx) in products" :key="idx">
              <td>
                <label class="cor-preta"><b>{{ p.nm }} </b></label><label class="letra-media cor-preta">
                  <span v-for="(a, idx2) in p.adicionaispergunta" :key="idx2">{{ a.nm }},
                  </span>

                  <!-- <span v-on="p.obs">obs: {{ p.obs }}, </span>-->
                </label>
              </td>
              <!--<td><b>R$ {{ parseFloat(totalp = p.vl * p.quantity).toFixed(2) }}</b></td>-->
              <td>
                <label class="cor-preta">
                  <span v-if="p.vl_promoSemAdd > 0">
                    <span v-if="p.vl_promo > 0">
                      <b> R$ {{ p.vl_promo }} </b>
                    </span>
                    <span v-else>
                      <b>  R$ {{ p.vl_promoSemAdd }} </b>
                    </span>
                  </span>
                  <span v-else>
                    <b> R$ {{ p.vl }} </B>
                  </span>
                </label>
              </td>
              <td>
                <button @click="menosqtd(p)" class="btn btn-dark">-</button>
              </td>
              <td>
                <label class="cor-preta"><b>{{ p.quantity }}</b></label>
              </td>
              <td>
                <button @click="somarqtd(p)" class="btn btn-dark">+</button>
              </td>
              <td>
                <button @click="removeFromCart(idx)" class="btn btn-danger">
                  X
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <!--<b><span v-show="products.length">Total Produto: R$ {{ parseFloat(totalp).toFixed(2) }}</span></b><br><br>-->
        <h4>
          <b><label class="cor-preta">Total: R$ {{ parseFloat(total).toFixed(2) }}</label></b>
        </h4>
        <br />
        <!--<b>Alguma observação ?</b>
			<textarea class="form-control" v-model="obs" id="obs" name="obs" rows="1" placeholder="Ex: Digite as observações aqui..."></textarea><br>-->
        <!--<h5>Pedido na <div id="minhadiv"></div></h5><br>-->
        <table border="0">
          <thead>
            <tr>
              <td width="350" valign="top">
                <li align="left">
                  <router-link style="background-color: #dc3545" to="/" class="btn btn-dark">Continuar Pedido
                  </router-link>
                </li>
              </td>
              <td width="100">
                <li align="center"></li>
              </td>
              <td width="480" valign="top">
                <li align="right">
                  <!--<button @click='salvarvendaproduto(products, total)'><router-link to='/pedidos' class="btn btn-dark">Confirmar Pedido</router-link></button>-->
                  <button style="background-color: #006400" @click="salvarvendaproduto(products, total)"
                    class="btn btn-dark">
                    Confirmar Pedido
                  </button>
                </li>
              </td>
            </tr>
          </thead>
        </table>

        <!--<p><router-link to='/' class="btn btn-dark">Continuar Pedido</router-link></p><br>
			<p><button @click='salvarvendaproduto(products, total)'><router-link to='/pedidos' class="btn btn-dark">Confirmar Pedido</router-link></button></p><br>-->
      </div>
    </div>
    <br />
    <footer class="main-footer" align="center">
      <b class="cor-preta">Todos os direitos reservados.</b><br />
      <b class="cor-preta">&copy; 2022
        <a target="”_blank”" href="https://www.panterafood.com.br">Pantera Food</a>.</b><br />
      <img width="100" src="https://apppanterafood.com.br/DeliveryCenter/3/logo/pantera.svg" />
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Venda from "../services/venda";
import Swal from "sweetalert2";
import SecureLS from "secure-ls";
var ls = new SecureLS({ encodingType: "aes" });

export default {
  name: "Cart",
  data() {
    return {
      adicionais: [],
    };
  },
  computed: {
    ...mapGetters({
      products: "cartProducts",
    }),
    total() {
      return this.products.reduce((total, p) => {
        if(p.vl_promoSemAdd > 0){
          if(p.vl_promo > 0){
            return total + p.vl_promo * p.quantity;
          }else{
            return total + vl_promoSemAdd * p.quantity;
          }
        }else{
          return total + p.vl * p.quantity;
        }
      }, 0);
    },
  },
  methods: {
    menosqtd(p) {
      if (p.quantity >= "2") {
        p.quantity -= 1;
      } else {
        Swal.fire({
          title: "Obrigatório ter pelo menos um item desse produto.",
          confirmButtonColor: "#000000",
        });
        //alert("Obrigatório ter pelo menos um item desse produto.");
      }
    },

    somarqtd(p) {
      p.quantity += 1;
      //alert(JSON.stringify(index));
    },
    /* del(index) {
      this.products.splice(index, 1);
    }, */

    async salvarvendaproduto(products) {
      var d1 = this.$store.state.date_token;
      var d2 = moment().format("YYYY-MM-DD hh:mm:ss");
      var diff = moment(d2, "YYYY-MM-DD HH:mm:ss").diff(
        moment(d1, "YYYY-MM-DD HH:mm:ss")
      );
      diff = diff / 60000;

      if (this.$store.state.funcionamento === "0") {
        Swal.fire({
          title: "Estabelecimento fechado",
          confirmButtonColor: "#000000",
        });
        //alert("Estabelecimento Fechado");
      } else if (diff > 30) {
        Swal.fire({
          title: "Tempo de conexão expirou! Leia o QRcode novamente!",
          confirmButtonColor: "#000000",
        });
      } else {
        var v = new Object();

        if (
          this.$store.state.serie == "COMANDA" ||
          this.$store.state.serie == "comanda" ||
          this.$store.state.serie == "CARTAO" ||
          this.$store.state.serie == "cartao"
        ) {
          /* var resposta = prompt("Qual o número da mesa que você está ?"); */
          const { value: mesa } = await Swal.fire({
            title: "Qual o número da mesa que você está ?",
            input: "text",
            inputPlaceholder: "Ex: 1",
            confirmButtonColor: "#006400",
            cancelButtonColor: "#dc3545",
            showCancelButton: true,
          });

          var resposta = mesa;

          v.mesa = resposta;
          v.serie = this.$store.state.serie;
          v.num_serie = this.$store.state.num_serie;
          //console.log(v.serie, "   ", v.num_serie, "   ", "Comanda");
          v.total = this.products.reduce((total, p) => {
           if(this.products.vl_promo > 0){
          return total + p.vl_promo * p.quantity;
        }else{
          return total + p.vl * p.quantity;
        }
          }, 0);
        } else {
          if (
            this.$store.state.serie == "MESA" ||
            this.$store.state.serie == "mesa"
          ) {
            v.mesa = null;
            v.serie = this.$store.state.serie;
            v.num_serie = this.$store.state.num_serie;
            //console.log(v.serie, "   ", v.num_serie, "   ", "Mesa");
            v.total = this.products.reduce((total, p) => {
              return total + p.vl * p.quantity;
            }, 0);
          }
        }

        v.products = products;

        //alert(v.mesa);
        if (this.$store.state.serie == "COMANDA" && v.mesa < 1) {
          Swal.fire({
            title: "Por favor, preencha o número da mesa.",
            confirmButtonColor: "#000000",
          });
          //alert('Por favor, preencha o número da mesa.');
        } else {
          if (
            this.$store.state.serie == "COMANDA" &&
            (v.mesa == null || v.mesa == "")
          ) {
            Swal.fire({
              title: "Por favor, preencha o número da mesa.",
              confirmButtonColor: "#000000",
            });
            //alert('Por favor, preencha o número da mesa.');
          } else {
            if (this.$store.state.serie == "COMANDA" && isNaN(v.mesa)) {
              Swal.fire({
                title: "Digite apenas números!",
                confirmButtonColor: "#000000",
              });
              //alert('Digite apenas números!');
            } else {
              if (this.$store.state.serie == "COMANDA" && v.mesa == "0") {
                Swal.fire({
                  title: "Por favor, preencha o número da mesa.",
                  confirmButtonColor: "#000000",
                });
                //alert('Por favor, preencha o número da mesa.');
              } else {
                if (this.products == "") {
                  Swal.fire({
                    title: "Por favor, escolha um produto do cardápio.",
                    confirmButtonColor: "#000000",
                  });
                  //alert('Por favor, escolha um produto do cardápio.');
                } else {
                  if (
                    this.$store.state.serie == "" ||
                    this.$store.state.num_serie == "" ||
                    this.$store.state.serie == null ||
                    this.$store.state.num_serie == null
                  ) {
                    Swal.fire({
                      title: "Por favor, escolha um QR CODE da mesa.",
                      confirmButtonColor: "#000000",
                    });
                    //alert('Por favor, escolha um QR CODE da mesa.');
                  } else {
                    //alert('inserido');

                    Venda.salvarvenda(v)
                      .then(function (response) {
                        Swal.fire({
                          title: response.data,
                          confirmButtonColor: "#000000",
                        });
                      })
                      .catch(function (error) {
                        alert(error);
                      });
                    this.$store.commit("setZera", []);
                    this.$router.push("/");
                  }
                }
              }
            }
          }
        }
      }
    },

    ...mapActions(["removeFromCart", "removeFromCartAd"]),
  },
};
</script>
